<template>
  <div class="panel">
    <div class="cardth">
      <div class="head">
        <div class="line">
          <!-- 省份选择 -->
          <el-select
            v-model="sheng"
            placeholder="省"
            filterable
            style="width: 100px"
            @change="handleChange($event, 1)"
          >
            <el-option
              v-for="(item, index) in addressList"
              :key="index + 'sheng'"
              :label="item.name"
              :value="item.code"
            />
          </el-select>

          <!-- 城市选择 -->
          <el-select
            v-model="shi"
            placeholder="市"
            filterable
            style="width: 100px; margin-left: 20px"
            @change="handleChange($event, 2)"
          >
            <el-option
              v-for="(item, index) in shiList"
              :key="index + 'shi'"
              :label="item.name"
              :value="item.code"
            />
          </el-select>

          <!-- 县区选择 -->
          <el-select
            v-model="xian"
            placeholder="县"
            filterable
            style="width: 100px; margin-left: 20px"
            @change="handleChange($event, 3)"
          >
            <el-option
              v-for="(item, index) in xianList"
              :key="index + 'xian'"
              :label="item.name"
              :value="item.code"
            />
          </el-select>

          <!-- 设备选择 -->
          <el-select
            v-model="deviceEnd"
            filterable
            @change="selectType"
            style="margin-left: 20px; width: 220px"
          >
            <el-option
              v-for="item in marker"
              :key="item.id"
              :value="item.device"
              :label="item.device_name"
            />
          </el-select>
        </div>

        <!-- 历史维度切换 -->
        <span class="history">
          <el-button @click="pr('moon', 3)" :type="butprimary.moon"
            >月</el-button
          >
          <el-button @click="pr('week', 2)" :type="butprimary.week"
            >周</el-button
          >
          <el-button @click="pr('sun', 1)" :type="butprimary.sun">日</el-button>

          <div class="block">
            <el-date-picker
              v-if="dataType === 2"
              v-model="timedata.week"
              type="week"
              format="yyyy 第 WW 周"
              value-format="yyyy-MM-dd"
              placeholder="选择周"
              :picker-options="setDisabled"
              @change="getweek"
            />
            <el-date-picker
              v-if="dataType === 3"
              v-model="timedata.moon"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择月"
              :picker-options="setDisabled"
              @change="getmoon"
            />
            <el-date-picker
              v-if="dataType === 1"
              v-model="timedata.sun"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="setDisabled"
              @change="getsun"
            />
          </div>
        </span>
        <span class="export" @click="downloadsc">导出图表数据</span>
      </div>
    </div>

    <!-- 图表展示区域 -->
    <div class="card">
      <!-- 月度统计对比图 -->
      <template v-if="dataType === 3">
        <div v-for="(item, index) in chartOptionsMax" :key="'max-' + index">
          <h3>{{ item.name }}</h3>
          <v-chart
            class="chart"
            style="margin-bottom: 20px"
            :option="item.option"
            :autoresize="true"
          />
        </div>
      </template>

      <!-- 常规数据趋势图 -->
      <div v-for="(item, index) in chartsData" :key="'normal-' + index">
        <h3>{{ item.name }}</h3>
        <v-chart
          class="chart"
          style="margin-bottom: 20px"
          :option="item.chartOptions"
          :autoresize="true"
        />
      </div>
    </div>

    <!-- 下载弹窗面板 -->
    <div class="ancklick" :class="{ anc2: anclk }">
      <h1>
        <span>下载选择</span>
        <span class="iconqq" @click="downloadsc">x</span>
      </h1>
      <div>
        <el-button :type="tppring === 2 ? 'primary' : ''" @click="boot(2)">
          小时数据
        </el-button>
        <el-button :type="tppring === 1 ? 'primary' : ''" @click="boot(1)">
          分钟数据
        </el-button>
        <el-button type="warning" style="margin-left: 50px" @click="boot(3)">
          下载
        </el-button>
      </div>
    </div>

    <!-- 体验会员提示弹窗 -->
    <el-dialog
      title="体验会员"
      :visible.sync="dialogVisible"
      width="500px"
      @close="dialogVisible = false"
    >
      <div class="vip-container">
        <div class="vc-it" v-if="!vipInfo">
          您还不是会员，可通过以下三种方式获取下载次数！
        </div>
        <div class="vc-it" v-else>
          会员已过期，可通过以下两种方式获取下载次数！
        </div>

        <div class="vc-i">
          1. 点击<span class="vc-ii" @click="openVipHandle">{{
            vipInfo ? "立即续费" : "立即开通"
          }}</span
          >，去{{ vipInfo ? "续费" : "开通" }}会员。
        </div>

        <div class="vc-i">
          2.
          可通过天气币兑换下载次数，在春之天气小程序中进入斗天地菜单，观看广告后可获取天气币，已有天气币可<span
            class="vc-ii"
            @click="integralData"
            >立即兑换</span
          >
        </div>

        <template v-if="!vipInfo">
          <div class="vc-i">
            3.
            扫描下方二维码，关注公众号，再观看一次广告，可获得免费体验会员兑换码，将兑换码填入到下方输入框中可兑换免费会员，兑换码有效期10分钟！
          </div>
          <div class="vip-c1">
            <img :src="qrUrl" alt="QR Code" />
          </div>
          <div class="vip-in">
            <el-input v-model="vipCode" placeholder="请输入兑换码" />
            <div class="vip-btn">
              <el-button type="primary" @click="exchangeHandle"
                >立即兑换</el-button
              >
            </div>
          </div>
        </template>
      </div>
    </el-dialog>

    <!-- 天气币兑换弹窗 -->
    <el-dialog
      title="天气币兑换"
      :visible.sync="integralVisible"
      width="500px"
      @close="integralVisible = false"
    >
      <div class="vip-container">
        <div class="vc-i">
          天气币余额:
          <span class="vc-ii">{{
            userIncomeData.userCurrencyAccountWeather?.balance || 0
          }}</span>
        </div>
        <div class="vc-i">
          站主币余额:
          <span class="vc-ii">{{
            userIncomeData.userCurrencyAccountStation?.balance || 0
          }}</span>
        </div>
        <div class="vc-i">
          日数据下载需 {{ userIncomeData.dayFileIncome }} 天气币
        </div>
        <div class="vc-i">
          周数据下载需 {{ userIncomeData.weekFileIncome }} 天气币
        </div>
        <div class="vc-i">
          月数据下载需 {{ userIncomeData.monFileIncome }} 天气币
        </div>

        <h1 style="margin-top: 20px"><span>下载选择</span></h1>
        <div style="display: flex; justify-content: center">
          <el-button :type="tppring === 2 ? 'primary' : ''" @click="boot(2)"
            >小时数据</el-button
          >
          <el-button :type="tppring === 1 ? 'primary' : ''" @click="boot(1)"
            >分钟数据</el-button
          >
        </div>
        <div class="vip-in">
          <div class="vip-btn">
            <el-button type="primary" @click="integralHandle"
              >立即下载</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { addressList } from "./cityData";
import dayjs from "dayjs";
import { $device } from "@/services";
import { toXlsx } from "@/utils/xlsx.js";
import { chartOption, getChinese } from "./chartsOption";
import { maxchartoptionhelper } from "./maxoptions";
import { $user as $userAdmin } from "@/services/admin";

// 常量配置：Excel 导出列定义
const BASE_COLUMNS = [
  { prop: "index", label: "序号" },
  { prop: "upDate", label: "上传日期(北京时/GMT+8)" },
  { prop: "upTime", label: "上传时间" },
  { prop: "tempIn", label: "室内温度(℃)" },
  { prop: "tempOut", label: "室外温度(℃)" },
  { prop: "humidityIn", label: "室内湿度(%)" },
  { prop: "humidityOut", label: "室外湿度(%)" },
  { prop: "hpaAbs", label: "气压(hPa)" },
  { prop: "windSpeed", label: "风速(m/s)" },
  { prop: "windDir", label: "风向(°)" },
  { prop: "maxDayWind", label: "每日最大风(m/s)" },
  { prop: "windSpeed2Min", label: "2分钟平均风速(m/s)" },
  { prop: "windSpeed10Min", label: "10分钟平均风速(m/s)" },
  { prop: "windDir2Min", label: "2分钟平均风向" },
  { prop: "windDir10Min", label: "10分钟平均风向" },
  { prop: 'rain', label: '分钟降雨量(mm)',  },
  { prop: "solarRadiation", label: "太阳辐射(W/m2)" },
  { prop: "uv", label: "紫外线辐射指数" },
];

export default {
  name: "GisDetail",
  data() {
    return {
      butprimary: {
        sun: "primary",
        moon: "",
        week: "",
        datatimes: 1,
      },
      timedata: {
        sun: new Date(),
        moon: new Date(),
        week: new Date(),
      },
      region: "",
      items: [],
      checkTime: dayjs().subtract(2, "m").format("YYYYMMDDHHmm").concat("00"),
      timerange: [
        dayjs().format("YYYYMMDD000000"),
        dayjs().subtract(-1, "day").format("YYYYMMDD000000"),
      ],
      period: "month",
      marker: [],
      deviceEnd: "",
      device_name: "",
      device_type: "",
      anclk: false,
      tppring: 2, // 1: 分钟, 2: 小时
      dataType: 1, // 1: 日, 2: 周, 3: 月
      setDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      chartsData: [],
      chartOptionsMax: [],
      addressList,
      sheng: "",
      shiList: [],
      shi: "",
      xianList: [],
      xian: "",
      vipInfo: null,
      dialogVisible: false,
      vipCode: "",
      qrUrl: "",
      integralVisible: false,
      userIncomeData: {
        userCurrencyAccountWeather: { balance: 0 },
        userCurrencyAccountStation: { balance: 0 },
      },
      deviceInfo: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    this.getConnect();
    this.getVipInfo();
  },
  methods: {
    // 获取气象数据并渲染图表
    async getData() {
      // 请求前先清空旧图表数据，避免提前返回时仍展示上一次的结果
      this.chartsData = [];
      const params = {
        type: this.dataType,
        startTime: this.timerange[0],
        endTime: this.timerange[1],
        device: this.deviceEnd,
      };

      this.getDeviceInfo(params.device);
      const res = await $device.weatherDetail(params);
      if(res.code !== 200) {
        this.$message.error(res.msg);
        return;
      }
      const data = res.data;

      // 1. 初始化数据结构
      const obj = {
        tempIn: [],
        tempOut: [],
        humidityOut: [],
        humidityIn: [],
        hpaAbs: [],
        windSpeed: [],
        windDir: [],
        rain: [],
        solarRadiation: [],
        uv: [],
        time: [],
      };

      // 2. 填充数据
      data?.forEach((item) => {
        Object.keys(obj).forEach((key) => {
          if (item[key] !== undefined) obj[key].push(item[key]);
        });
      });

      // 3. 格式化时间坐标
      const times = obj.time.map((v) => {
        const s = v?.toString();
        return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)} ${s.slice(
          8,
          10
        )}:${s.slice(10, 12)}:${s.slice(12, 14)}`;
      });

      // 4. 生成图表配置项
      const arr = [];
      const keys = Object.keys(obj).filter(
        (k) =>
          k !== "time" &&
          k !== "humidityOut" &&
          k !== "tempOut" &&
          k !== "hpaRel"
      );

      keys.forEach((key) => {
        const chartsObj = { name: "", chartOptions: {} };
        let legend = [];
        let series = [];

        if (key === "tempIn") {
          chartsObj.name = "温度(℃)";
          legend = ["室内温度(℃)", "室外温度(℃)"];
          series = [
            {
              name: "室内温度(℃)",
              type: "line",
              smooth: true,
              data: obj.tempIn,
            },
            {
              name: "室外温度(℃)",
              type: "line",
              smooth: true,
              data: obj.tempOut,
            },
          ];
        } else if (key === "humidityIn") {
          chartsObj.name = "湿度(%)";
          legend = ["室内湿度(%)", "室外湿度(%)"];
          series = [
            {
              name: "室内湿度(%)",
              type: "line",
              smooth: true,
              data: obj.humidityIn,
            },
            {
              name: "室外湿度(%)",
              type: "line",
              smooth: true,
              data: obj.humidityOut,
            },
          ];
        } else {
          const chineseName = getChinese(key);
          chartsObj.name = chineseName;
          legend = [chineseName];
          series = [
            {
              name: chineseName,
              type: key === "rain" ? "bar" : "line",
              barWidth: key === "rain" ? "20" : undefined,
              smooth: true,
              data: obj[key],
            },
          ];
        }

        chartsObj.chartOptions = chartOption(
          legend,
          series,
          this.period,
          times
        );
        arr.push(chartsObj);
      });

      this.chartsData = arr;
    },

    async getDeviceInfo(device) {
      const res = await $device.deviceInfo(device);
      if (res.code === 200) this.deviceInfo = res.data;
    },

    // 维度切换处理 (日、周、月)
    pr(value, nb) {
      Object.keys(this.butprimary).forEach((key) => {
        if (typeof this.butprimary[key] === "string") this.butprimary[key] = "";
      });
      this.butprimary[value] = "primary";
      this.butprimary.datatimes = nb;
      this.dataType = nb;

      const methodsMap = { 1: "getsun", 2: "getweek", 3: "getmoon" };
      this[methodsMap[nb]]();
    },

    openVipHandle() {
      this.$store.commit("SET_vipInfoUpdate", 2);
      this.dialogVisible = false;
    },

    // 统一的文件下载执行逻辑
    executeDownload(data, type) {
      const columns = [...BASE_COLUMNS];

      // 如果是小时数据，增加降雨量细分列
      if (type === 2) {
        const rainCols = [
          { prop: "rain", label: "小时降雨量(mm)" },
          { prop: "dayRain", label: "日降雨量(mm)" },
          { prop: "monthRain", label: "月降雨量(mm)" },
          { prop: "yearRain", label: "年降雨量(mm)" },
        ];
        // 在风向之后插入降雨量列 (简单处理直接 push)
        const rainIndex = columns.findIndex((c) => c.prop === "rain");
        if (rainIndex > -1) columns.splice(rainIndex, 1, ...rainCols);
        else columns.push(...rainCols);
      } else {
        // 分钟数据
        const rainIdx = columns.findIndex((c) => c.prop === "rain");
        if (rainIdx > -1) columns[rainIdx].label = "分钟降雨量(mm)";
      }

      const formattedData = data.map((item, index) => {
        const sTime = item.time?.toString();
        return {
          ...item,
          index: index + 1,
          upDate: `${sTime.slice(0, 4)}.${sTime.slice(4, 6)}.${sTime.slice(
            6,
            8
          )}`,
          upTime: `${sTime.slice(8, 10)}:${sTime.slice(10, 12)}`,
        };
      });

      const deviceObj = this.marker.find(
        (item) => item.device === this.deviceEnd
      );
      const fileName = `${type === 2 ? "小时" : "分钟"}-${deviceObj.id}.${
        deviceObj.device_name
      }(${this.timerange[0].slice(0, 8)}-${this.timerange[1].slice(0, 8)})`;
      const sheet = `${deviceObj.id}.${deviceObj.device_name}`.replace(
        /[:\\/?*\[\]]/g /* eslint-disable-line */,
        ""
      );

      toXlsx({
        columns,
        dataSource: formattedData,
        fileName,
        sheet,
      });
    },

    // 积分兑换下载
    async integralHandle() {
      const params = {
        type: this.tppring,
        startTime: this.timerange[0],
        endTime: this.timerange[1],
        device: this.deviceEnd,
        dateType: this.dataType,
      };

      const res = await $userAdmin.integralExportData(params);
      if (res.code === 200) {
        this.$message.success("兑换成功，正在下载数据！");
        this.integralVisible = false;
        this.executeDownload(res.data, params.type);
      } else {
        this.$message.error(res.msg);
      }
    },

    async integralData() {
      const res = await $userAdmin.userIncome();
      if (res.code === 200) {
        this.userIncomeData = res.data;
        this.dialogVisible = false;
        this.integralVisible = true;
      }
    },

    async getVipInfo() {
      const res = await $userAdmin.vipInfo();
      if (res.code === 200) this.vipInfo = res.data;
    },

    async exchangeHandle() {
      if (this.vipCode.length !== 8) {
        return this.$message.error("兑换码8位，请输入正确的长度！");
      }
      const res = await $userAdmin.exchangeVip(this.vipCode);
      if (res.code === 200) {
        this.getVipInfo();
        this.$store.commit("SET_vipInfoUpdate", 1);
        this.$message.success("体验会员兑换成功！");
        this.dialogVisible = false;
      }
    },

    // 点击下载按钮的前置逻辑判断
    async downloadsc() {
      const userId = this.userInfo?.id;
      // 如果是自己的设备，直接下载
      if (this.deviceInfo && this.deviceInfo.userId == userId) {
        this.anclk = !this.anclk;
        this.tppring = 2;
        return;
      }

      // 访客下载逻辑
      if (!this.vipInfo) {
        const res = await $userAdmin.vipCode();
        this.qrUrl = res.data.url;
        this.dialogVisible = true;
      } else {
        // 检查会员下载次数
        const checkMap = { 1: "dayFile", 2: "weekFile", 3: "monthFile" };
        if (this.vipInfo[checkMap[this.dataType]] === 0) {
          this.integralData();
        } else {
          this.anclk = !this.anclk;
          this.tppring = 2;
        }
      }
    },

    // 弹窗内部的确定下载
    async boot(value) {
      if (value !== 3) {
        this.tppring = value;
      } else {
        const params = {
          type: this.tppring,
          startTime: this.timerange[0],
          endTime: this.timerange[1],
          device: this.deviceEnd,
          dateType: this.dataType,
        };
        const res = await $device.expoetExcl(params);
        this.executeDownload(res.data, params.type);
        this.anclk = false;
      }
    },

    // 初始化连接
    async getConnect(webId) {
      this.marker = [];
      const res = await $device.getConnectData({
        value: "status",
        time: this.checkTime,
        device_name: "",
        webId: webId || "",
      });

      if (res.result === 1) {
        if (res.data.length) {
          this.marker = res.data;
          this.deviceEnd = res.data[0].device;
          this.device_name = res.data[0].device_name;
          this.device_type = res.data[0].device_type;
        } else {
          this.deviceEnd = this.device_name = this.device_type = "";
        }
        this.getData();
        this.getmaxandmin();
      }
    },

    selectType(val) {
      const selected = this.marker.find((item) => item.device === val);
      this.deviceEnd = val;
      this.device_name = selected.device_name;
      this.device_type = selected.device_type;
      this.getData();
      this.getmaxandmin();
    },

    // 日期切换逻辑
    getmoon() {
      this.timerange = [
        dayjs(this.timedata.moon).format("YYYYMM01000000"),
        dayjs(this.timedata.moon)
          .subtract(-1, "month")
          .format("YYYYMM01000000"),
      ];
      this.period = "month";
      this.getData();
      this.getmaxandmin();
    },
    getsun() {
      this.period = "day";
      this.timerange = [
        dayjs(this.timedata.sun).format("YYYYMMDD000000"),
        dayjs(this.timedata.sun).subtract(-1, "day").format("YYYYMMDD000000"),
      ];
      this.getData();
    },
    getweek() {
      this.period = "week";
      this.timerange = [
        dayjs(this.timedata.week).startOf("week").format("YYYYMMDD000000"),
        dayjs(this.timedata.week).endOf("week").format("YYYYMMDD000000"),
      ];
      this.getData();
      this.getmaxandmin();
    },

    // 获取月度最高最低值
    async getmaxandmin() {
      const params = {
        startTime: this.timerange[0],
        endTime: this.timerange[1],
        device: this.deviceEnd,
      };
      // 请求前先清空旧的最高/最低图表数据
      this.chartOptionsMax = [];
      const res = await $device.getMaxAndMinTem(params);
      if(res.code !== 200) {
        this.$message.error(res.msg);
        return;
      }

      const stats = {
        maxArrall: [],
        minArrall: [],
        timeArrall: [],
        maxArr1all: [],
        minArr1all: [],
      };

      res.data.forEach((item) => {
        const t = item.time?.toString();
        const dateStr = `${t?.slice(0, 4)}-${t?.slice(4, 6)}-${t?.slice(6, 8)}`;
        const timeStr = `${t?.slice(8, 10)}:${t?.slice(10, 12)}:${t?.slice(
          12,
          14
        )}`;

        if (item.statType === 1) {
          // 最高
          stats.maxArrall.push({ type: item.type, val: item.dayVal });
          stats.maxArr1all.push({
            type: item.type,
            val: { value: item.dayVal, time: timeStr, date: dateStr },
          });
          const v = item.dayTime?.toString();
          stats.timeArrall.push({
            type: item.type,
            val: `${v?.slice(0, 4)}-${v?.slice(4, 6)}-${v?.slice(6, 8)}`,
          });
        } else if (item.statType === 2) {
          // 最低
          stats.minArrall.push({ type: item.type, val: item.dayVal });
          stats.minArr1all.push({
            type: item.type,
            val: { value: item.dayVal, time: timeStr, date: dateStr },
          });
        }
      });

      this.maxAndMinDataHelper(stats);
    },

    maxAndMinDataHelper(data) {
      this.chartOptionsMax = [];
      const types = [
        { id: 1, name: "气温", unit: "°C" },
        { id: 2, name: "湿度", unit: "(%)" },
        { id: 3, name: "气压", unit: "hPa" },
        { id: 4, name: "风速", unit: "m/s" },
        { id: 5, name: "光照", unit: "w/m²" },
        { id: 6, name: "紫外线", unit: "强度" },
      ];

      types.forEach((type) => {
        const maxVal = data.maxArrall
          .filter((i) => i.type === type.id)
          .map((i) => i.val);
        const minVal = data.minArrall
          .filter((i) => i.type === type.id)
          .map((i) => i.val);
        const maxDetail = data.maxArr1all
          .filter((i) => i.type === type.id)
          .map((i) => i.val);
        const minDetail = data.minArr1all
          .filter((i) => i.type === type.id)
          .map((i) => i.val);
        const times = data.timeArrall
          .filter((i) => i.type === type.id)
          .map((i) => i.val);

        if (maxVal.length) {
          this.chartOptionsMax.push({
            name: `最高${type.name}&最低${type.name}`,
            option: maxchartoptionhelper(
              `最高${type.name}${type.unit}`,
              `最低${type.name}${type.unit}`,
              maxVal,
              maxDetail,
              minVal,
              minDetail,
              times
            ),
          });
        }
      });
    },

    handleChange(e, type) {
      if (type === 1) {
        const obj = this.addressList.find((item) => item.code === e);
        this.shi = this.xian = "";
        this.shiList = obj?.children || [];
        this.xianList = [];
      } else if (type === 2) {
        const shiObj = this.shiList.find((item) => item.code === e);
        this.xian = "";
        this.xianList = shiObj?.children || [];
      }
      this.getConnect(e);
    },
  },
};
</script>

<style lang="less" scoped>
/* 保持原有样式不变 */
::-webkit-scrollbar {
  width: 20px;
  background-color: #283142;
}

::-webkit-scrollbar-button {
  &:decrement,
  &:increment {
    background: #323e4e;
    border-radius: 6px 6px 0px 0px;
  }
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #283142;
}

::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #005770;
}

/deep/ .el-range-editor.el-input__inner {
  background: transparent;
}
/deep/ .el-range-input {
  background: transparent;
  color: #00a0e9;
}
/deep/ .el-date-editor--datetimerange.el-input__inner {
  width: 450px !important;
  height: 35px;
}
/deep/ .el-range-separator {
  height: 30px;
  color: #00a0e9;
}

.panel {
  padding: 20px;
  width: 100%;
  height: 100%;
  .cardth {
    border-radius: 20px;
    padding: 0px 40px 20px 20px;
    .head {
      height: 100px;
      width: 100%;
      padding: 30px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .line {
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .history {
        display: flex;
      }
      .export {
        cursor: pointer;
        user-select: none;
        line-height: 35px;
        height: 35px;
        border-radius: 10px;
        text-align: center;
        font-size: 16px;
        color: #fff;
        width: 150px;
        background: linear-gradient(90deg, #3ab87f 0%, #0ab1e4 100%);
      }
    }
  }
  .card {
    border-radius: 20px;
    padding: 0px 20px 20px 20px;
    position: relative;
    height: 85vh;
    h3 {
      font-size: 24px;
      color: #666;
    }
    .chart {
      border-radius: 20px;
      width: 100%;
      height: 35vh;
      overflow: hidden;
    }
  }
  .block {
    margin-left: 10px;
  }
  .ancklick {
    display: none;
    width: 500px;
    background-color: #fff;
    border: 1px solid #ccc;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2000;
    h1 {
      font-weight: 900;
      padding: 10px;
      color: #fff;
      background-color: #009fe9a8;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      .iconqq {
        cursor: pointer;
        color: #fff;
      }
    }
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px;
    }
  }
  .anc2 {
    display: block;
  }
}

.vip-container {
  padding: 20px;
  .vc-it {
    font-size: 18px;
    text-align: center;
    color: #333;
  }
  .vc-i {
    font-size: 16px;
    text-align: left;
    margin-top: 10px;
    line-height: 28px;
    .vc-ii {
      cursor: pointer;
      color: #00a0e9;
      &:hover {
        color: rgb(102, 177, 255);
      }
    }
  }
  .vip-c1 {
    text-align: center;
    margin: 20px 0;
    width: 100%;
    height: 200px;
    display: block;
    img {
      width: 200px;
      height: 200px;
    }
  }
  .vip-in {
    margin-top: 20px;
    text-align: center;
    .vip-btn {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>